var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tooltip',{attrs:{"effect":"dark","content":_vm.isFullScreen ? '退出全屏' : '全屏',"placement":"bottom"}},[_c('el-button',{staticClass:"screen-full-btn",attrs:{"type":"text"},on:{"click":_vm.click}},[_c('i',{staticClass:"iconfont",class:_vm.isFullScreen?'icon-btn_cancelFullscreen':'icon-quanping'})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-558822a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Screenfull/index.vue
// module id = Jpy7
// module chunks = 8